"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketTaggingOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketTaggingOutput.js.map